import { useDispatch, useSelector } from 'react-redux';

// Design System
import { submitForm } from 'jl-design-system/redux/actions/form/formActions';

// Types
import { AppDispatch } from 'types/RootState.types';

// Config
import goToPaymentState from './GoToPayment.state';
import routeConstants from '../../constants/routeConstants';
import { submitDeliveryDetails, onUseAddressButtonClick } from '../../redux/actions/delivery/deliveryActions';
import { CLICK_AND_COLLECT_FORM_ID } from '../../utils/form/configs/clickAndCollect';
import { COLLECTOR_DETAILS_FORM_ID } from '../../utils/form/configs/collectorDetails';

// Styles
import styles from './go-to-payment.scss';

const GoToPayment = () => {
  const dispatch: AppDispatch = useDispatch();
  const {
    collectionPointSearchComplete,
    collectionSearchFormMounted,
    collectorDetailsFormMounted,
    deliveryDetailsFormMounted,
    enableButton,
    pathname = '',
  } = useSelector(goToPaymentState);

  const continueToPaymentButtonVisible = !!document.querySelector('button[data-testid^="deliveryDetailsForm"]') ||
    !!document.querySelector('button[data-testid="batched-deliveries-submit-button"]');
  const useThisAddressButtonVisible = !!document.querySelector('[data-testid="delivery-address-use-address"]');

  const buttonText = <span className={styles.button}>2. Payment</span>;

  if (!enableButton) return buttonText;

  let onClickAction;

  if (pathname.includes(routeConstants.CLICK_AND_COLLECT)) {
    if (collectionSearchFormMounted && !collectionPointSearchComplete) {
      onClickAction = () => dispatch(submitForm(CLICK_AND_COLLECT_FORM_ID));
    }

    if (collectorDetailsFormMounted) {
      onClickAction = () => dispatch(submitForm(COLLECTOR_DETAILS_FORM_ID));
    }
  }

  if (pathname.includes(routeConstants.DELIVERY)) {
    if (useThisAddressButtonVisible) {
      onClickAction = () => dispatch(onUseAddressButtonClick());
    }

    if (deliveryDetailsFormMounted && continueToPaymentButtonVisible) {
      onClickAction = () => dispatch(submitDeliveryDetails());
    }
  }

  if (!onClickAction) return buttonText;

  return (
    <button
      className={styles.button}
      data-testid="go-to-payment-button"
      onClick={onClickAction}
      type="button"
    >
      {buttonText}
    </button>
  );
};

export default GoToPayment;
